import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        {/* Section Header */}
        <div className="mb-12 md:mb-16">
          <p className="text-xs md:text-sm font-semibold text-primary-500 uppercase tracking-widest mb-3">
            14 Organized Categories
          </p>
          <h2 className="font-heading text-3xl md:text-5xl font-extrabold text-foreground-950 leading-[1.1]">
            Shop Every Style
          </h2>
          <p className="font-heading text-2xl md:text-4xl font-bold text-foreground-500 mt-1">
            In One Click
          </p>
        </div>

        {/* Category Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-50 rounded-xl p-5 md:p-6 hover:bg-primary-50/50 transition-all duration-200 cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center mb-4">
                <i className={`${cat.icon} text-2xl text-foreground-800 group-hover:text-primary-500 transition-colors`}></i>
              </div>
              <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-2">
                {cat.name}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {cat.description}
              </p>
              <div className="flex items-center gap-1 mt-4 text-primary-500 text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                Browse Category
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-sm"></i>
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* View All CTA */}
        <div className="mt-10 text-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 bg-foreground-950 text-background-50 px-7 py-3.5 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            Explore All Categories
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-base"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}